'use strict';

var React = require('react');

(function (SupportedKey) {
    SupportedKey[SupportedKey["ENTER"] = 13] = "ENTER";
    SupportedKey[SupportedKey["ARROW_LEFT"] = 37] = "ARROW_LEFT";
    SupportedKey[SupportedKey["ARROW_UP"] = 38] = "ARROW_UP";
    SupportedKey[SupportedKey["ARROW_RIGHT"] = 39] = "ARROW_RIGHT";
    SupportedKey[SupportedKey["ARROW_DOWN"] = 40] = "ARROW_DOWN";
    SupportedKey[SupportedKey["ESCAPE_KEY"] = 27] = "ESCAPE_KEY";
    SupportedKey[SupportedKey["SPACE"] = 32] = "SPACE";
})(exports.SupportedKey || (exports.SupportedKey = {}));
var useOnKeyboardPress = function (key, onPress, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    React.useEffect(function () {
        var escFunction = function (event) {
            if (event.keyCode === key) {
                onPress(event);
            }
        };
        if (!isEnabled) {
            return undefined;
        }
        document.addEventListener('keydown', escFunction, false);
        return function () {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [key, onPress, isEnabled]);
};

exports.useOnKeyboardPress = useOnKeyboardPress;
//# sourceMappingURL=useOnKeyboardPress-d580d97f.js.map
